import { render, staticRenderFns } from "./VerifyWheel.vue?vue&type=template&id=4a73c976&scoped=true"
import script from "./VerifyWheel.vue?vue&type=script&lang=js"
export * from "./VerifyWheel.vue?vue&type=script&lang=js"
import style0 from "./VerifyWheel.vue?vue&type=style&index=0&id=4a73c976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73c976",
  null
  
)

export default component.exports